
import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'

import Tooltip from '@/common/components/Tooltip.vue'
import ProductOptionsDropdown from 'common/components/ProductOptionsDropdown.vue'
import SectionTitle from '@/product/components/SectionTitle.vue'
import BaseImage from '@/common/components/BaseImage.vue'
import WearableProductMessage from '@/product/components/WearableProductMessage.vue'
import ProductOptionItem from '@/product/components/ProductOptionItem.vue'

import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { SkuSelectionOption } from '@/model/printableSku'

export default Vue.extend({
  components: {
    ProductOptionsDropdown,
    Tooltip,
    SectionTitle,
    WearableProductMessage,
    ProductOptionItem,
    BaseImage
  },
  props: {
    titleIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      showModalEditPattern: false,
      unavailableOptionTooltipText: {
        image: '現在の設定ではご利用になれません\nクリックすると利用可能なオプショ\nンで設定します',
        text: 'クリックすると利用可能な\nオプションで設定します'
      }
    }
  },
  computed: {
    ...mapGetters([
      'product', 'estimate',
      'wrappingSelectedOption','currentSKUImageView','skuImageView'
    ]),
    placeholderSquare() {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    isDesktopView() {
      return window.innerWidth > 768
    }
  },
  methods: {
    ...mapMutations([
      'setSelectedId'
    ]),
    onChangeBasicSelection(content: string, option: SkuSelectionOption) {
      if (!option.selectable && option.first_option_selectable_id) {
        this.$emit('showSnackbar')
        this.setSelectedId({ content: 'first_selected_option', id: option.first_option_selectable_id })
      }
      if (!option.selectable && option.second_option_selectable_id) {
        this.$emit('showSnackbar')
        this.setSelectedId({ content: 'second_selected_option', id: option.second_option_selectable_id })
      }
      this.setSelectedId({ content, id: option.id })
      this.refreshProductInfo({
        loadImageView: true,
        disabledLoading: true
      })
    },
    onHoverOption(itemOption?: any) {
      if (this.currentSKUImageView.display_order !== 1){
        this.$emit('setFirstSlideImage', this.skuImageView.id)
      }
      let hasOption = itemOption && itemOption.sku_image
      let image = document.getElementById('sliderImageId') as HTMLImageElement

      if (image) {
        image.src = hasOption ? itemOption.sku_image : this.skuImageView.thumbnail
        this.$emit('setImageDescription', hasOption ? itemOption.sku_image_caption : this.skuImageView.caption)
      }
    },
    refreshProductInfo(payload?: { param?: number, queries?: any, loadImageView?: boolean, disabledLoading?: boolean }) {
      this.$emit('refreshProductInfo', payload || {})
    }
  }
})
